webpackJsonp([1,0],[
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _routeWuyan = __webpack_require__(76);
	
	var _routeWuyan2 = _interopRequireDefault(_routeWuyan);
	
	var _wuyan = __webpack_require__(254);
	
	var _wuyan2 = _interopRequireDefault(_wuyan);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var main = __webpack_require__(14);
	var Vue = main.Vue;
	var VueRouter = main.VueRouter;
	var lockPage = main.lockPage;
	
	Vue.use(VueRouter);
	
	Vue.component('lock-page', lockPage);
	
	var router = new VueRouter({
	    hashbang: false,
	    history: false,
	    saveScrollPosition: true,
	    transitionOnLoad: false
	});
	(0, _routeWuyan2.default)(router);
	router.start(_wuyan2.default, '#app');

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    host: "http://www.scwywh.com/",
	    dateLocale: {
	        separator: " 至 ",
	        format: "YYYY-MM-DD HH:mm:00",
	        daysOfWeek: ["日", "一", "二", "三", "四", "五", "六"],
	        monthNames: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"]
	    },
	    qiniu: {
	        URL: 'wuyan/qiniu/token',
	        deleteURL: 'wuyan/qiniu',
	        listURL: 'wuyan/qiniu',
	
	        wuyan: {
	            domain: 'http://img.scwywh.com/'
	        }
	    }
	
	};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _promise = __webpack_require__(35);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		option: {
			key: '',
			host: _config2.default.host
		},
	
		load: function load(url, params, callback, type) {
			var result = "";
			var self = this;
			$.ajax({
				async: callback ? true : false,
				timeout: 150000,
				type: type ? type : 'POST',
				url: url,
				data: params,
				processData: true,
				datatype: 'json',
				success: function success(data) {
					var curData = '';
					if (data.responseData && data.responseData.data) {
						curData = data.responseData.data;
					} else if (data.response && data.response.sub_msg) {
						curData = data.response;
						if (data.response.code == 3) {
							self.topRightInfoTips({
								content: data.response.sub_msg
							});
							setTimeout(function () {
								location.href = '/unlogin/login.html';
							}, 2000);
						}
					} else {
						curData = data;
					}
	
					if (callback) {
						callback(curData);
					} else {
						result = curData;
					}
				},
				error: function error(XMLHttpRequest, textStatus, errorThrown) {
					self.topRightInfoTips({
						content: XMLHttpRequest + textStatus + errorThrown
					});
				}
			});
			return result;
		},
	
		getUrlParams: function getUrlParams(purl, isNoToLower) {
			isNoToLower = isNoToLower || false;
			var url = purl || window.location.href;
			var paraObj = {};
			if (url.indexOf('?') < 0) {
				return paraObj;
			}
			url = url.replace('#', '');
			var paraString = url.substring(url.indexOf('?') + 1, url.length).split('&');
			if (!isNoToLower) {
				var j;
				for (var i = 0; j = paraString[i]; i++) {
					paraObj[j.substring(0, j.indexOf('=')).toLowerCase()] = decodeURIComponent(j.substring(j.indexOf('=') + 1, j.length));
				}
			} else {
				for (var i = 0; j = paraString[i]; i++) {
					try {
						paraObj[j.substring(0, j.indexOf('='))] = decodeURIComponent(j.substring(j.indexOf('=') + 1, j.length));
					} catch (ex) {
						paraObj[j.substring(0, j.indexOf('='))] = unescape(j.substring(j.indexOf('=') + 1, j.length));
					}
				}
			}
			return paraObj;
		},
	
	
		topRightInfoTips: function topRightInfoTips(options) {
			var option,
			    style = 'position: fixed;right:0px;top:4px;font-size: 16px;',
			    html = '';
			$('.alert .close').click();
			option = {
				color: 'warning',
				title: '警告!',
				content: '',
				time: '3000'
			};
			$.extend(option, options);
			html = '<div class="alert alert-' + option.color + ' alert-dismissible fade in" style="' + style + '" role="alert"> ' + '<button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">×</span></button> ' + '<strong>' + option.title + '</strong> ' + option.content + ' </div>';
			$('body').append(html);
			var setT = setTimeout(function () {
				$('.alert .close').click();
			}, option.time);
			$('.alert').on('click', '.close', function () {
				clearInterval(setT);
			});
			$('.alert').on('mouseover', function () {
				clearInterval(setT);
			});
			$('.alert').on('mouseout', function () {
				setT = setTimeout(function () {
					$('.alert .close').click();
				}, option.time);
			});
		},
	
		uploadQNImg: function uploadQNImg(option, callback) {
			var self = this;
			!option.domain && (option.domain = 'img.ludanmall.com');
			var defaultOption = {
				runtimes: 'html5,flash,html4',
				browse_button: option.browse_button,
				uptoken: option.uptoken,
				domain: option.domain,
				container: option.container,
				get_new_uptoken: false,
				max_file_size: '1mb',
				flash_swf_url: 'path/of/plupload/Moxie.swf',
				max_retries: 3,
				dragdrop: true,
				chunk_size: '4mb',
				auto_start: true,
				isCover: false,
				key: 'ldwsc',
				init: {
					'FilesAdded': function FilesAdded(up, files) {
						plupload.each(files, function (file) {});
					},
					'BeforeUpload': function BeforeUpload(up, file) {},
					'UploadProgress': function UploadProgress(up, file) {
						file.callbackType = 'UploadProgress';
						callback(file);
					},
					'FileUploaded': function FileUploaded(up, file, info) {
						var domain = up.getOption('domain');
	
						info = JSON.parse(info);
						info.domain = domain;
						info.callbackType = 'FileUploaded';
						callback(info);
					},
					'Error': function Error(up, err, errTip) {},
					'UploadComplete': function UploadComplete() {},
					'Key': function Key(up, file) {
						var key = option.key + self.option.key;
						file.name = file.name.replace(/\.[a-z]*[A-Z]*$/, '');
						if (!option.isCover) {
							file.name += '_' + new Date().getTime();
						}
						key += file.name;
						return key;
					}
				}
			};
			$.extend(defaultOption, option);
			var uploader = Qiniu.uploader(defaultOption);
		},
	
		CopyToClipboard: function CopyToClipboard(content) {
			var textToClipboard = content;
	
			var success = true;
			if (window.clipboardData) {
				window.clipboardData.setData("Text", textToClipboard);
			} else {
				var forExecElement = this.CreateElementForExecCommand(textToClipboard);
	
				this.SelectContent(forExecElement);
	
				var supported = true;
	
				try {
					if (window.netscape && netscape.security) {
						netscape.security.PrivilegeManager.enablePrivilege("UniversalXPConnect");
					}
	
					success = document.execCommand("copy", false, null);
				} catch (e) {
					success = false;
				}
	
				document.body.removeChild(forExecElement);
			}
	
			if (success) {
				this.topRightInfoTips({
					type: 'success',
					title: '恭喜您,拷贝成功!'
				});
			} else {
				this.topRightInfoTips({
					type: 'success',
					title: 'soory,拷贝失败!'
				});
			}
		},
		SelectContent: function SelectContent(element) {
			var rangeToSelect = document.createRange();
			rangeToSelect.selectNodeContents(element);
	
			var selection = window.getSelection();
			selection.removeAllRanges();
			selection.addRange(rangeToSelect);
		},
		CreateElementForExecCommand: function CreateElementForExecCommand(textToClipboard) {
			var forExecElement = document.createElement("div");
	
			forExecElement.style.position = "absolute";
			forExecElement.style.left = "-10000px";
			forExecElement.style.top = "-10000px";
	
			forExecElement.textContent = textToClipboard;
			document.body.appendChild(forExecElement);
	
			forExecElement.contentEditable = true;
	
			return forExecElement;
		},
	
		getSocketNum: 0,
		getSocket: function (_getSocket) {
			function getSocket() {
				return _getSocket.apply(this, arguments);
			}
	
			getSocket.toString = function () {
				return _getSocket.toString();
			};
	
			return getSocket;
		}(function () {
			var self = this;
			var sockjsAddr = "http://www.ludanmall.com:8080/hello/nickname";
			var sockjsClient;
			var onopen = function onopen() {
				$("#status").val("已连接");
			};
			var onmessage = function onmessage(e) {
				$("div.comeInfo").css("display", "block");
				var info = JSON.parse(e.data);
				if (info) {
					self.topRightInfoTips({
						content: '你收到一条差评消息,订单号:' + info,
						time: '5000'
					});
					top_bar.messageList();
				}
			};
			var onclose = function onclose() {
				this.getSocketNum++;
				if (this.getSocketNum < 10) {
					getSocket();
				}
			};
			sockjsClient = new SockJS(sockjsAddr + "/" + localStorage.getItem('merchantId'));
			sockjsClient.onopen = onopen;
			sockjsClient.onmessage = onmessage;
			sockjsClient.onclose = onclose;
		}),
	
		loadFiles: function loadFiles(files) {
			var files = files ? files : [];
			for (var i = 0; i < files.length; i++) {
				var creatDom = '';
				var creat = true;
				if (/\.css$/.test(files[i])) {
					$('head link').each(function (index, item) {
						$(item).attr('href');
						if ($(item).attr('href') == files[i]) {
							creat = false;
						}
					});
					if (!creat) {
						continue;
					}
					creatDom = '<link type="text/css" rel="stylesheet" href="' + files[i] + '"/>';
				} else if (/\.js/.test(files[i])) {
					$('head script').each(function (index, item) {
						$(item).attr('src');
						if ($(item).attr('src') == files[i]) {
							creat = false;
						}
					});
					if (!creat) {
						continue;
					}
					creatDom = '<script src="' + files[i] + '"></script>';
				}
				$('head').append(creatDom);
			}
		},
	
		cutTime: function cutTime(data) {
			data.forEach(function (item) {
				item.cutName = item.name.replace(/\_\d{1,}$/, '');
			});
			return data;
		},
	
		getAllType: function getAllType(type, callback) {
			var self = this;
			var typeName = sessionStorage.getItem("typeName");
	
			var getVersion = new _promise2.default(function (resolve, reject) {
				var url = self.option.host + "wuyan/user/version",
				    param = {};
				if (type == 'admin') {
					url = self.option.host + "wuyan/admin/version";
				}
				self.load(url, param, function (data) {
					var list = {};
					if (data.code) {
						list = code;
					} else {
						data = data.data;
						for (var i = 0; i < data.length; i++) {
							list[data[i].id] = data[i].name;
						}
					}
					resolve(list);
				}, 'get');
			});
	
			var getSubject = new _promise2.default(function (resolve, reject) {
				var url = self.option.host + "wuyan/user/subject",
				    param = {};
				if (type == 'admin') {
					url = self.option.host + "wuyan/admin/subject";
				}
				self.load(url, param, function (data) {
					var list = {};
					if (data.code) {
						list = code;
					} else {
						data = data.data;
						for (var i = 0; i < data.length; i++) {
							list[data[i].id] = data[i].name;
						}
					}
					resolve(list);
				}, 'get');
			});
	
			var getGrade = new _promise2.default(function (resolve, reject) {
				var url = self.option.host + "wuyan/user/grade",
				    param = {};
				if (type == 'admin') {
					url = self.option.host + "wuyan/admin/grade";
				}
				self.load(url, param, function (data) {
					var list = {};
					if (data.code) {
						list = code;
					} else {
						data = data.data;
						for (var i = 0; i < data.length; i++) {
							list[data[i].id] = data[i].name;
						}
					}
					resolve(list);
				}, 'get');
			});
	
			var getGeneral = new _promise2.default(function (resolve, reject) {
				var url = self.option.host + "wuyan/user/general",
				    param = {};
				if (type == 'admin') {
					url = self.option.host + "wuyan/admin/general";
				}
				self.load(url, param, function (data) {
					var list = {};
					if (data.code) {
						list = code;
					} else {
						data = data.data;
						for (var i = 0; i < data.length; i++) {
							list[data[i].id] = data[i].name;
						}
					}
					resolve(list);
				}, 'get');
			});
			_promise2.default.all([getVersion, getSubject, getGrade, getGeneral]).then(function (data) {
	
				var type = {
					version: data[0],
					subject: data[1],
					grade: data[2],
					general: data[3]
				};
				sessionStorage.setItem('typeName', (0, _stringify2.default)(type));
				callback(type);
			});
		}
	
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 3 */,
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(15)
	__vue_template__ = __webpack_require__(24)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(34)
	__vue_template__ = __webpack_require__(51)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(54);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(53);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _lockPage = __webpack_require__(27);
	
	var _lockPage2 = _interopRequireDefault(_lockPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(21);
	__webpack_require__(36);
	__webpack_require__(22);
	
	
	var Rxports = {
	    Vue: _vue2.default, VueRouter: _vueRouter2.default, lockPage: _lockPage2.default
	};
	
	module.exports = Rxports;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _page = __webpack_require__(23);
	
	var _page2 = _interopRequireDefault(_page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        turnPage: Object
	    },
	    data: function data() {
	        return {};
	    },
	    methods: {
	        pageFn: function pageFn(index) {
	            var pageNo = this.turnPage.pageNo;
	            var pageCount = Math.ceil(this.turnPage.totalCount / this.turnPage.pageSize);
	            switch (index) {
	                case 'prev':
	                    pageNo--;
	                    break;
	                case 'next':
	                    pageNo++;
	                    break;
	                default:
	                    pageNo = index;
	            }
	            if (pageNo < 1) {
	                pageNo = 1;
	            } else if (pageNo > pageCount) {
	                pageNo = pageCount;
	            }
	            this.$set('turnPage.pageNo', pageNo);
	            this.dispatchParent();
	        },
	
	        dispatchParent: function dispatchParent() {
	            this.$dispatch('child-turn-page', this.turnPage);
	        },
	        filterPage: function filterPage(index) {
	            return this.turnPage.pageNo - 3 <= index && index < this.turnPage.pageNo + 3;
	        }
	    }
	};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    data: function data() {
	        return {
	            wH: 0,
	            show: false,
	            content: '正在加载'
	        };
	    },
	    ready: function ready() {
	        this.$set('wH', $(window).height());
	        this.hSty();
	    },
	
	    events: {
	        'parent-lock-page-data': function parentLockPageData(obj) {
	            var _this = this;
	
	            this.$set('show', obj.show);
	            obj.content && this.$set('content', obj.content);
	            setTimeout(function () {
	                _this.$set('show', false);
	            }, 3000);
	        }
	    },
	    methods: {
	        hSty: function hSty() {
	            return {
	                marginTop: this.wH / 2 + 8 + 'px'
	            };
	        }
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, exports) {

	module.exports = " <div class=\"turn-page clearfix\" style=\"padding: 8px\"> <div class=\"pull-right pages\"> <span v-if=\"Math.ceil(turnPage.totalCount/turnPage.pageSize)>1\" @click=\"pageFn('prev')\" class=\"glyphicon glyphicon-menu-left\"></span> <span @click=pageFn(1) v-if=\"turnPage.pageNo-3>=1\">1</span> <em v-if=\"turnPage.pageNo-3>1\">……</em> <template v-for=\"one in Math.ceil(turnPage.totalCount/turnPage.pageSize)\"> <span v-if=filterPage($index) :class=\"$index+1==turnPage.pageNo?'active':''\" @click=pageFn($index+1) data-index={{$index+1}}>{{$index+1}}</span> </template> <em v-if=\"turnPage.pageNo+3<Math.ceil(turnPage.totalCount/turnPage.pageSize)&&turnPage.pageNo+3+1!=Math.ceil(turnPage.totalCount/turnPage.pageSize)\">……</em> <span @click=pageFn(Math.ceil(turnPage.totalCount/turnPage.pageSize)) v-if=\"turnPage.pageNo+3<Math.ceil(turnPage.totalCount/turnPage.pageSize)\">{{Math.ceil(turnPage.totalCount/turnPage.pageSize)}}</span> <span v-if=\"Math.ceil(turnPage.totalCount/turnPage.pageSize)>1\" @click=\"pageFn('next')\" class=\"glyphicon glyphicon-menu-right\"></span> </div> </div> ";

/***/ }),
/* 25 */
/***/ (function(module, exports) {

	module.exports = " <div class=lock-page v-show=show> <h4 :style=hSty><i class=\"glyphicon glyphicon-repeat\"></i> {{content}}……</h4> </div> ";

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(44)
	__vue_script__ = __webpack_require__(33)
	__vue_template__ = __webpack_require__(52)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__vue_script__ = __webpack_require__(16)
	__vue_template__ = __webpack_require__(25)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    props: ['src'],
	    created: function created() {},
	
	    ready: function ready() {
	        this.music.src = this.src;
	        var vm = this;
	        this.$nextTick(function () {
	            vm.audioPlayer();
	        });
	    },
	    data: function data() {
	        return {
	            audio: "",
	            music: {
	                src: "",
	                fullTime: "",
	                playTime: "",
	                state: ""
	            }
	        };
	    },
	
	    computed: {
	        'fullTime': function fullTime() {
	            var m = parseInt(this.music.fullTime / 60),
	                s = parseInt(this.music.fullTime % 60);
	            if (m < 10) {
	                m = '0' + m;
	            }
	            if (s < 10) {
	                s = '0' + s;
	            }
	            return m + ':' + s;
	        },
	        'playerTime': function playerTime() {
	            var m = parseInt(this.music.playTime / 60),
	                s = parseInt(this.music.playTime % 60);
	            if (m < 10) {
	                m = '0' + m;
	            }
	            if (s < 10) {
	                s = '0' + s;
	            }
	            return m + ':' + s;
	        },
	        'progress': function progress() {
	            return this.music.playTime / this.music.fullTime * 100;
	        }
	    },
	    methods: {
	        audioPlayer: function audioPlayer() {
	            var vm = this;
	            var audio = document.querySelector('audio');
	            vm.audio = audio;
	            setInterval(function () {
	                vm.music.fullTime = audio.duration;
	                vm.music.playTime = audio.currentTime;
	            }, 100);
	        },
	        playOrPause: function playOrPause() {
	            if (this.audio.paused) {
	                this.audio.play();
	            } else if (!this.audio.paused) {
	                this.audio.pause();
	            }
	        },
	        backOrSpeed: function backOrSpeed(type) {
	            if (type === 'back') {
	                this.audio.currentTime = this.audio.currentTime - 10;
	            } else if (type === 'speed') {
	                this.audio.currentTime = this.audio.currentTime + 10;
	            }
	        },
	        selectTime: function selectTime(e) {
	            var progress = e.offsetX / 200;
	            this.audio.currentTime = this.music.fullTime * progress;
	        }
	    }
	};

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _common = __webpack_require__(2);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: {
	        options: Object
	    },
	    data: function data() {
	        return {
	            host: _config2.default.host,
	            domain: _config2.default.qiniu.wuyan.domain,
	            token: '',
	            files: ['http://cdn.staticfile.org/Plupload/2.1.1/plupload.full.min.js', 'http://cdn.staticfile.org/Plupload/2.1.1/moxie.min.js', 'http://cdn.staticfile.org/qiniu-js-sdk/1.0.14-beta/qiniu.js']
	        };
	    },
	    created: function created() {
	        _common2.default.loadFiles(this.files);
	    },
	    ready: function ready() {
	        this.getToken();
	    },
	
	    methods: {
	        uploadQNImg: function uploadQNImg() {
	            var self = this;
	            var qiNiuContainer = this.$els.qiNiuContainer;
	            var qiNiuButton = this.$els.qiNiuButton;
	            var token = this.token;
	            var domain = this.domain;
	            var Qiniu2 = new QiniuJsSDK();
	
	            var defaultOption = {
	                runtimes: 'html5,flash,html4',
	                browse_button: qiNiuButton,
	                uptoken: token,
	                domain: domain,
	                container: qiNiuContainer,
	                get_new_uptoken: false,
	                max_file_size: this.options.max_file_size ? this.options.max_file_size : '5mb',
	                max_retries: 1,
	                dragdrop: true,
	                chunk_size: '4mb',
	                auto_start: true,
	                isCover: false,
	                key: 'unPath',
	                init: {
	                    'FilesAdded': function FilesAdded(up, files) {
	                        plupload.each(files, function (file) {});
	                    },
	                    'BeforeUpload': function BeforeUpload(up, file) {},
	                    'UploadProgress': function UploadProgress(up, file) {
	                        file.callbackType = 'UploadProgress';
	                        self.$dispatch('child-qiniu-data', file);
	                    },
	                    'FileUploaded': function FileUploaded(up, file, info) {
	                        var domain = up.getOption('domain');
	
	                        info = JSON.parse(info);
	                        info.domain = domain;
	                        info.callbackType = 'FileUploaded';
	                        self.options.uptype && (info.picType = self.options.uptype);
	                        self.$dispatch('child-qiniu-data', info);
	                    },
	                    'Error': function Error(up, err, errTip) {
	                        console.error("This Qiniu upload is failure");
	                        console.error(err);
	                        var options = self.options;
	                        if (err.code == -600) {
	                            _common2.default.topRightInfoTips({ content: '上传大小不能超过' + (options.max_file_size ? options.max_file_size : defaultOption.max_file_size) });
	                        }
	                    },
	                    'UploadComplete': function UploadComplete() {},
	                    'Key': function Key(up, file) {
	                        var options = self.options;
	                        var merchantId = 'wuyuan';
	                        var key = options.key ? options.key : defaultOption.key;
	                        merchantId = merchantId ? merchantId : '888888';
	                        key = merchantId + '/' + key;
	                        if (!options || !options.isCover) {
	                            file.name = file.name.replace(/\./, '_' + new Date().getTime() + '.');
	                        }
	                        key += '/' + file.name;
	                        return key;
	                    }
	                }
	            };
	            $.extend(defaultOption, this.options);
	            var uploader = Qiniu2.uploader(defaultOption);
	        },
	        getToken: function getToken() {
	            var self = this;
	            var URL = this.host + 'wuyan/qiniu/token';
	            _common2.default.load(URL, '', function (data) {
	                self.$set('token', data.token);
	
	                setTimeout(function () {
	                    self.uploadQNImg();
	                }, 500);
	            }, 'get');
	        }
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/2.505760f.jpg";

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/3.315ec3f.jpg";

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/6.83dfa57.jpg";

/***/ }),
/* 48 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 49 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 50 */
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),
/* 51 */
/***/ (function(module, exports) {

	module.exports = " <div v-el:qi-niu-container> <div class=\"btn btn-default\" v-el:qi-niu-button> <i class=\"glyphicon glyphicon-plus\"></i> <template v-if=\"options.uptype == 'wenjian'\"> <span>上传文件</span> </template> <template v-else> <span>上传图片</span> </template> </div> <template v-if=\"options.uptype == 'wenjian'\"> <small>(请上传文件)</small> </template> </div> ";

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div _v-1f56230d=\"\"> <div class=listenPlayer _v-1f56230d=\"\"> <audio :src=src _v-1f56230d=\"\"></audio> <div class=player-border _v-1f56230d=\"\"> <div @click=\"backOrSpeed('back')\" class=button _v-1f56230d=\"\"> <img src=" + __webpack_require__(48) + " alt=\"\" _v-1f56230d=\"\"> </div> <div @click=playOrPause class=button _v-1f56230d=\"\"> <img src=" + __webpack_require__(49) + " alt=\"\" _v-1f56230d=\"\"> </div> <div @click=\"backOrSpeed('speed')\" class=button _v-1f56230d=\"\"> <img src=" + __webpack_require__(50) + " alt=\"\" _v-1f56230d=\"\"> </div> <div class=time-view _v-1f56230d=\"\"> <span _v-1f56230d=\"\">{{playerTime}}</span>/<span _v-1f56230d=\"\">{{fullTime}}</span> </div> <div class=_progress-bar _v-1f56230d=\"\"> <div @click=selectTime class=_progress-bg _v-1f56230d=\"\"> <div v-bind:style=\"{width:progress+'%'}\" class=_bar _v-1f56230d=\"\"></div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(185)
	__vue_script__ = __webpack_require__(102)
	__vue_template__ = __webpack_require__(226)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(155)
	__vue_script__ = __webpack_require__(105)
	__vue_template__ = __webpack_require__(196)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(182)
	__vue_script__ = __webpack_require__(110)
	__vue_template__ = __webpack_require__(223)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 74 */,
/* 75 */,
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	exports.default = function (router) {
	    router.map({
	        '/': {
	            name: '首页',
	            component: __webpack_require__(72),
	            subRoutes: {
	                '/': {
	                    name: '首页',
	                    component: __webpack_require__(73)
	                }
	            }
	        },
	        '/index': {
	            name: '首页',
	            component: __webpack_require__(72),
	            subRoutes: {
	                '/pc': {
	                    name: '首页',
	                    component: __webpack_require__(73)
	                },
	
	                '/workList': {
	                    name: '课件列表',
	                    component: __webpack_require__(264)
	                },
	                '/workInfo': {
	                    name: '课件详情',
	                    component: __webpack_require__(263)
	                },
	                '/norisukeList': {
	                    name: '产品列表',
	                    component: __webpack_require__(260)
	                },
	                '/shopInfo': {
	                    name: '店铺详情',
	                    component: __webpack_require__(261)
	                },
	                '/norisukeInfo': {
	                    name: '教辅详情',
	                    component: __webpack_require__(259)
	                },
	
	                '/listendownpc': {
	                    name: '单元听力下载列表',
	                    component: __webpack_require__(258)
	                },
	                '/listenbookpc': {
	                    name: '听力下载展示',
	                    component: __webpack_require__(257)
	                },
	                '/findinfopc': {
	                    name: '公司文化，系统消息',
	                    component: __webpack_require__(256)
	                },
	                '/tellOur': {
	                    name: '联系我们',
	                    component: __webpack_require__(262)
	                }
	            }
	        }
	    });
	};

/***/ }),
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = {
	    created: function created() {
	        window.addEventListener('hashchange', function () {
	            document.body.scrollTop = 0;
	            document.documentElement.scrollTop = 0;
	        });
	    }
	};

/***/ }),
/* 102 */
/***/ (function(module, exports) {

	"use strict";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _common = __webpack_require__(2);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            host: _config2.default.host,
	            URLcs: _common2.default.getUrlParams(),
	            email: '',
	            password: '',
	            reg: {
	                address: '',
	                email: '',
	                name: '',
	                password: '',
	                phone: '',
	                school: '',
	                passwordS: ''
	            },
	            localdata: {
	                role: localStorage.getItem('wyrole'),
	                name: localStorage.getItem('wyname'),
	                id: localStorage.getItem('wyid')
	            }
	        };
	    },
	    events: {},
	    components: {},
	    created: function created() {},
	    ready: function ready() {},
	    methods: {
	        cReg: function cReg() {
	            var url = this.host + 'wuyan/user/Register';
	            var self = this;
	            var postParam = {};
	            postParam = this.reg;
	            _common2.default.load(url, (0, _stringify2.default)(postParam), function (data) {
	                if (data.code == -1) {
	                    _common2.default.topRightInfoTips({ title: data.message });
	                } else {
	                    _common2.default.topRightInfoTips({ title: data.message });
	                }
	            });
	        },
	
	        cLogin: function cLogin() {
	            var url = this.host + 'wuyan/user/Login';
	            var self = this;
	            var postParam = {};
	            postParam.password = this.password;
	            postParam.email = this.email;
	            _common2.default.load(url, (0, _stringify2.default)(postParam), function (data) {
	                if (data.code == -1) {
	                    _common2.default.topRightInfoTips({ title: data.message });
	
	                    self.findjurisdiction(data.id);
	                } else {
	                    _common2.default.topRightInfoTips({ title: data.message });
	                }
	            });
	        },
	
	        findjurisdiction: function findjurisdiction(id) {
	            var url = this.host + 'wuyan/user/info/' + id;
	            var self = this;
	            _common2.default.load(url, '', function (data) {
	                localStorage.setItem('wyrole', data.data.role);
	                localStorage.setItem('wyname', data.data.name);
	                localStorage.setItem('wyid', data.data.id);
	                self.$set('localdata.role', data.data.role);
	                self.$set('localdata.name', data.data.name);
	                self.$set('localdata.id', data.data.id);
	            }, 'get');
	        },
	        out: function out() {
	            localStorage.setItem('wyrole', '');
	            localStorage.setItem('wyname', '');
	            localStorage.setItem('wyid', '');
	            this.$set('localdata.role', '');
	            this.$set('localdata.name', '');
	            this.$set('localdata.id', '');
	        }
	    }
	};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _common = __webpack_require__(2);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _page = __webpack_require__(4);
	
	var _page2 = _interopRequireDefault(_page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            host: _config2.default.host,
	            pageNo: 1,
	            pageData: {},
	            infodata: {}
	        };
	    },
	    watch: {},
	    events: {
	        'child-turn-page': function childTurnPage(obj) {
	            this.pageNo = obj.pageNo;
	            this.findinfo();
	        }
	    },
	    components: {
	        page: _page2.default
	    },
	    created: function created() {
	        this.findinfo();
	    },
	    ready: function ready() {},
	    methods: {
	        findinfo: function findinfo() {
	            var url = this.host + 'wuyan/user/notice';
	            var self = this;
	            var postParam = {};
	            postParam.pageSize = 20;
	            postParam.pageNo = this.pageNo;
	            _common2.default.load(url, postParam, function (data) {
	                if (data.hasOwnProperty('code')) {
	                    _common2.default.topRightInfoTips({ title: data.message });
	                } else {
	                    self.$set('infodata', data.data.list);
	                    self.infodata.forEach(function (a) {
	                        a.content = JSON.parse(a.content);
	                    });
	                    self.$set('pageData', data.data);
	                }
	            }, 'get');
	        }
	    }
	};

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _nav = __webpack_require__(255);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _footer = __webpack_require__(71);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {};
	    },
	    components: {
	        top: _nav2.default,
	        myFooter: _footer2.default
	    },
	    created: function created() {
	        window.addEventListener('hashchange', function () {
	            document.body.scrollTop = 0;
	            document.documentElement.scrollTop = 0;
	        });
	    },
	
	    methods: {}
	};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _qrcodeNpm = __webpack_require__(13);
	
	var _qrcodeNpm2 = _interopRequireDefault(_qrcodeNpm);
	
	var _common = __webpack_require__(2);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _page = __webpack_require__(4);
	
	var _page2 = _interopRequireDefault(_page);
	
	var _listenPlayer = __webpack_require__(26);
	
	var _listenPlayer2 = _interopRequireDefault(_listenPlayer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            host: _config2.default.host,
	            URLcs: _common2.default.getUrlParams(),
	            pageData: {},
	            datainfo: {},
	            url: '',
	            wyrole: localStorage.getItem('wyrole'),
	            qrcode: ''
	        };
	    },
	    events: {
	        'child-turn-page': function childTurnPage(obj) {
	            this.pageNo = obj.pageNo;
	            this.finddata();
	        }
	    },
	    components: {
	        page: _page2.default,
	        player: _listenPlayer2.default
	    },
	    created: function created() {
	        this.finddata();
	    },
	    ready: function ready() {
	        this.getQrcode();
	    },
	    methods: {
	        findthistl: function findthistl(url) {
	            this.$set('url', url);
	        },
	        tishi: function tishi() {
	            _common2.default.topRightInfoTips({
	                title: '没有下载权限！'
	            });
	        },
	        download: function download(index) {
	            if (localStorage.getItem('wyrole')) {} else {
	                this.tishi();
	            }
	        },
	        getQrcode: function getQrcode() {
	            var qr = _qrcodeNpm2.default.qrcode(4, 'M');
	
	            qr.addData("http://www.scwywh.com/mobile.html#/listenOneBook?id=" + this.URLcs.id);
	            qr.make();
	            var code = qr.createImgTag(4);
	            this.$set('qrcode', code);
	        },
	        finddata: function finddata() {
	            var url = this.host + 'wuyan/user/listenUnit';
	            var self = this;
	            var postParam = {};
	            postParam.listenId = this.URLcs.id;
	            postParam.pageNo = this.pageNo;
	            postParam.pageSize = 15;
	            _common2.default.load(url, postParam, function (data) {
	                if (data.hasOwnProperty('code')) {
	                    _common2.default.topRightInfoTips({
	                        title: '还没有相关听力！！'
	                    });
	                } else {
	                    self.$set('datainfo', data.data.list);
	                    self.$set('pageData', data.data);
	                }
	            }, 'get');
	        }
	    }
	};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _common = __webpack_require__(2);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _page = __webpack_require__(4);
	
	var _page2 = _interopRequireDefault(_page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            postParam: {},
	            host: _config2.default.host,
	            pageData: {},
	            infodata: {},
	            databanben: {},
	            generaldata: {},
	            generalId: 1,
	            pageNo: 1,
	            urlParams: _common2.default.getUrlParams()
	        };
	    },
	    events: {
	        'child-turn-page': function childTurnPage(obj) {
	            this.pageNo = obj.pageNo;
	            this.findinfo(this.generalId);
	        }
	    },
	    components: {
	        page: _page2.default
	    },
	    created: function created() {
	        this.findbanben();
	        this.findgeneral();
	    },
	    ready: function ready() {
	        var _this = this;
	
	        window.addEventListener('hashchange', function () {
	            _this.urlParams = _common2.default.getUrlParams();
	            _this.findbanben();
	            if (_this.urlParams.type == 'cn') {
	                $('.topnav ul li').eq(2).removeClass('active');
	            } else {
	                $('.topnav ul li').eq(3).removeClass('active');
	            }
	        });
	        if (this.urlParams.type == 'cn') {
	            $('.topnav ul li').eq(2).removeClass('active');
	        } else {
	            $('.topnav ul li').eq(3).removeClass('active');
	        }
	    },
	    methods: {
	        findgeneral: function findgeneral() {
	            var url = this.host + 'wuyan/user/general';
	            var self = this;
	            var postParam = {};
	            _common2.default.load(url, '', function (data) {
	                self.$set('generaldata', data.data);
	            }, 'get');
	        },
	
	        findbanben: function findbanben() {
	            var url = this.host + 'wuyan/admin/version';
	            var self = this;
	            var postParam = {};
	            _common2.default.load(url, postParam, function (data) {
	                self.$set('databanben', data.data);
	                self.findinfo();
	            }, 'get');
	        },
	        findinfo: function findinfo(generalId) {
	            this.generalId = generalId ? generalId : '';
	            var url = this.host + 'wuyan/user/listen';
	            var self = this;
	            var postParam = {};
	            postParam.generalId = this.generalId * 1;
	            postParam.subjectId = this.urlParams.type == 'en' ? 3 : 1;
	            postParam.pageNo = this.pageNo * 1;
	            postParam.pageSize = 20;
	            _common2.default.load(url, postParam, function (data) {
	                if (data.hasOwnProperty('code')) {
	                    data.data = { list: [], pageNO: 1, totalCount: 0 };
	                }
	                self.$set('infodata', data.data.list);
	                self.$set('pageData', data.data);
	                self.infodata.forEach(function (a) {
	                    self.databanben.forEach(function (b) {
	                        if (b.id == a.versionId) {
	                            a.versionId = b.name;
	                        }
	                    });
	                });
	            }, 'get');
	        }
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _common = __webpack_require__(2);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            urlParams: _common2.default.getUrlParams(location.href),
	            host: _config2.default.host,
	            shopList: {},
	            shopInfo: {},
	            pageOpt: {
	                list: {
	                    pageNo: 1
	                }
	            },
	            typeName: {}
	        };
	    },
	    created: function created() {
	        var self = this;
	        _common2.default.getAllType("admin", function (data) {
	            self.$set('typeName', data);
	            self.loadList();
	        });
	    },
	    methods: {
	        imgError: function imgError(index) {
	            this.$set('bookList.list[' + index + '].logo', 'http://qiniu.ludanmall.com/472/commend/logo/千库网-素材书图片_1480562667018.png');
	        },
	
	        loadList: function loadList() {
	            var url = this.host + "wuyan/admin/norisuke/",
	                params = {
	                id: this.urlParams.id
	            },
	                self = this;
	            _common2.default.load(url, params, function (data) {
	                if (data.code) {
	                    _common2.default.topRightInfoTips({
	                        title: data.message
	                    });
	                } else {
	                    self.$set("shopList", data.data);
	                    for (var i = 0; i < self.shopList.list.length; i++) {
	                        if (self.shopList.list[i].id == self.urlParams.id) {
	                            var one = self.shopList.list[i];
	                            one.generalName = self.typeName.general[one.generalId];
	                            one.versionName = self.typeName.version[one.versionId];
	                            self.$set("shopInfo", one);
	                        }
	                    }
	                }
	            }, 'get');
	        }
	    }
	};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _common = __webpack_require__(2);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            postParam: {},
	            host: _config2.default.host,
	            bookList: {},
	            pageOpt: {
	                list: {
	                    pageNo: 1
	                }
	            },
	            typeName: {},
	            generalId: 1
	        };
	    },
	    created: function created() {
	        var self = this;
	        _common2.default.getAllType("admin", function (data) {
	            self.$set('typeName', data);
	            self.loadList();
	        });
	    },
	    methods: {
	        imgError: function imgError(index) {
	            this.$set('bookList.list[' + index + '].logo', 'http://qiniu.ludanmall.com/472/commend/logo/千库网-素材书图片_1480562667018.png');
	        },
	
	        loadList: function loadList(key) {
	            (key || key === 0) && (this.generalId = key);
	            var url = this.host + "wuyan/admin/norisuke",
	                params = {
	                pageNo: this.pageOpt.pageNo,
	                pageSize: 100,
	                generalId: this.generalId
	
	            },
	                self = this;
	            _common2.default.load(url, params, function (data) {
	                if (data.code) {
	                    data.data = [];
	                }
	                self.$set("bookList", data.data);
	                self.$log();
	            }, 'get');
	        }
	
	    }
	};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _footer = __webpack_require__(71);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _common = __webpack_require__(2);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(32);
	exports.default = {
	    data: function data() {
	        return {
	            bookList: {},
	            shopList: {},
	            NoseList: {},
	            host: _config2.default.host,
	            topHeight: "",
	            typeName: {},
	            noseType: ''
	
	        };
	    },
	    components: {
	        myFooter: _footer2.default
	
	    },
	    created: function created() {
	        var self = this;
	        _common2.default.getAllType("admin", function (data) {
	            self.$set('typeName', data);
	            self.loadBook();
	            self.loadShop();
	            for (var i in self.typeName.general) {
	                self.noseType = i;
	                self.loadNose();
	            }
	        });
	    },
	
	    computed: {},
	
	    ready: function ready() {
	        var self = this;
	        setTimeout(function () {
	            self.init();
	        }, 3000);
	    },
	    beforeDestroy: function beforeDestroy() {
	        window.onscroll = function () {};
	    },
	
	    methods: {
	        init: function init() {
	            window.onscroll = function () {
	                var height = $(".swiper-first").offset().top - $(window).scrollTop();
	                if (height <= -480) {
	                    $(".qrcode").css({
	                        "position": "fixed",
	                        "top": "20px",
	                        "right": "0",
	                        "box-shadow": "1px 1px 1px 1px rgba(0, 0, 0, 0.2)"
	                    });
	                } else {
	                    $(".qrcode").css({
	                        "position": "absolute",
	                        "top": "520px",
	                        "right": "0",
	                        "box-shadow": "1px 1px 1px 1px rgba(0, 0, 0, 0)"
	                    });
	                }
	            };
	            this.$nextTick(function () {
	                var swiper = new Swiper('.swiper-container-list', {
	                    autoplay: 2000,
	                    autoplayDisableOnInteraction: false,
	                    slidesPerView: 'auto',
	                    loop: true
	                });
	                new Swiper('.swiper-container-shop', {
	                    autoplay: 2000,
	                    autoplayDisableOnInteraction: false,
	                    slidesPerView: 'auto',
	                    loop: this.shopList.list.length > 5 ? true : false
	                });
	                var swiper1 = new Swiper('.swiper-first', {
	                    autoplay: 3000,
	                    loop: true
	                });
	            });
	        },
	        imgError: function imgError() {},
	
	        loadBook: function loadBook() {
	            var url = this.host + "wuyan/user/book",
	                params = {
	                pageSize: 20
	            },
	                self = this;
	            _common2.default.load(url, params, function (data) {
	                if (data.code) {
	                    data.data = { list: [], pageNo: 1, totalCount: 0 };
	                }
	                self.$set("bookList", data.data);
	            }, 'get');
	        },
	        loadShop: function loadShop() {
	            var url = this.host + "wuyan/user/shop/all",
	                params = {
	                pageSize: 20
	            },
	                self = this;
	            _common2.default.load(url, params, function (data) {
	                if (data.code) {
	                    data.data = { list: [], pageNo: 1, totalCount: 0 };
	                } else {
	                    self.$set("shopList", data.data);
	                }
	            }, 'get');
	        },
	
	        loadNose: function loadNose() {
	            var url = this.host + "wuyan/user/norisuke",
	                params = {
	                generalId: this.noseType,
	                pageSize: 20
	            },
	                self = this;
	            _common2.default.load(url, params, function (data) {
	                if (data.code) {
	                    data.data = { list: [], pageNo: 1, totalCount: 1 };
	                } else {
	                    self.$set("NoseList[" + params.generalId + "]", data.data);
	                }
	            }, 'get');
	        }
	
	    }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _common = __webpack_require__(2);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            urlParams: _common2.default.getUrlParams(location.href),
	            host: _config2.default.host,
	            shopList: {},
	            shopInfo: {},
	            pageOpt: {
	                list: {
	                    pageNo: 1
	                }
	            },
	            typeName: {},
	            generalId: {}
	        };
	    },
	    created: function created() {
	        var self = this;
	        _common2.default.getAllType("admin", function (data) {
	            self.$set('typeName', data);
	            self.loadList();
	        });
	    },
	    methods: {
	        imgError: function imgError(index) {
	            this.$set('bookList.list[' + index + '].logo', 'http://qiniu.ludanmall.com/472/commend/logo/千库网-素材书图片_1480562667018.png');
	        },
	
	        loadList: function loadList() {
	            var url = this.host + "wuyan/user/shop/all",
	                params = {},
	                self = this;
	            _common2.default.load(url, params, function (data) {
	                if (data.code) {
	                    _common2.default.topRightInfoTips({
	                        title: data.message
	                    });
	                } else {
	                    self.$set("shopList", data.data);
	                    for (var i = 0; i < self.shopList.list.length; i++) {
	                        if (self.shopList.list[i].id == self.urlParams.id) {
	                            self.$set("shopInfo", self.shopList.list[i]);
	                        }
	                    }
	                }
	                self.$log();
	            }, 'get');
	        }
	
	    }
	};

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _common = __webpack_require__(2);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            host: _config2.default.host,
	            link: {}
	        };
	    },
	    created: function created() {
	        this.getInfo();
	    },
	
	    methods: {
	        getInfo: function getInfo() {
	            var url = this.host + 'wuyan/admin/notice/68';
	            var self = this;
	            _common2.default.load(url, '', function (data) {
	                if (!data.data) return;
	                data = data.data;
	                data.content = JSON.parse(data.content);
	                self.$set('link', data);
	            }, 'get');
	        }
	    }
	};

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(55);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(5);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _components$events$da;
	
	var _common = __webpack_require__(2);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _qiniu = __webpack_require__(8);
	
	var _qiniu2 = _interopRequireDefault(_qiniu);
	
	var _page = __webpack_require__(4);
	
	var _page2 = _interopRequireDefault(_page);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var qrCode = __webpack_require__(13);
	__webpack_require__(32);
	exports.default = (_components$events$da = {
	    components: {
	        qiniu: _qiniu2.default,
	        page: _page2.default
	    },
	    events: {
	        'child-qiniu-data': function childQiniuData(data) {
	            var url = data.domain + data.key;
	            if (data.callbackType == 'FileUploaded') {
	                if (data.picType == "img") {
	                    this.modal.ppt.pptImages.push(url);
	                } else {
	                    this.$set('modal.ppt.pptUrl', url);
	                }
	            }
	        }
	    },
	    data: function data() {
	        return {
	            host: _config2.default.host,
	            urlParams: _common2.default.getUrlParams(location.href),
	            bookInfo: {},
	            unitList: {},
	            PPTList: {},
	            selected: {
	                unit: {}
	            },
	            modal: {
	                unit: {},
	                ppt: {
	                    pptImages: []
	                },
	                del: {}
	            },
	            typeName: {},
	            qrcode: '',
	            pageOpt: {
	                ppt: {
	                    type: 'ppt',
	                    pageNo: 1,
	                    pageSize: 10
	                },
	                unit: {
	                    type: 'unit',
	                    pageNo: 1,
	                    pageSize: 10
	
	                }
	            },
	            wyrole: localStorage.getItem('wyrole')
	        };
	    },
	    created: function created() {
	        this.loadUnit();
	        this.loadBook();
	        var self = this;
	        _common2.default.getAllType("admin", function (data) {
	            self.$set('typeName', data);
	            self.getQrcode();
	        });
	    }
	}, (0, _defineProperty3.default)(_components$events$da, 'events', {
	    'child-turn-page': function childTurnPage(data) {
	        this.turnPage(data);
	    }
	
	}), (0, _defineProperty3.default)(_components$events$da, 'methods', {
	    imgError: function imgError(index) {
	        this.$set('PPTList.list[' + index + '].logo', 'http://qiniu.ludanmall.com/472/commend/logo/千库网-素材书图片_1480562667018.png');
	    },
	    noAllow: function noAllow() {
	        _common2.default.topRightInfoTips({
	            content: '权限不足'
	        });
	    },
	
	    getQrcode: function getQrcode() {
	        var qr = qrCode.qrcode(4, 'M');
	        qr.addData("http://www.scwywh.com/mobile.html#/pptInfo?id=" + this.urlParams.id);
	        qr.make();
	        var code = qr.createImgTag(4);
	        this.qrcode = code;
	    },
	
	    loadBook: function loadBook() {
	        var url = this.host + "wuyan/user/book/" + this.urlParams.id,
	            params = {},
	            self = this;
	        _common2.default.load(url, params, function (data) {
	            if (data.code) {
	                alert(data.message);
	            } else {
	                self.$set("bookInfo", data.data);
	            }
	        }, 'get');
	    },
	
	    loadUnit: function loadUnit() {
	        var url = this.host + "wuyan/user/unit",
	            params = {
	            bookId: this.urlParams.id,
	            pageNo: this.pageOpt.unit.pageNo,
	            pageSize: this.pageOpt.unit.pageSize
	
	        },
	            self = this;
	        _common2.default.load(url, params, function (data) {
	            if (data.code) {
	                _common2.default.topRightInfoTips({
	                    content: data.message
	                });
	            } else {
	                self.$set('unitList', data.data);
	                self.$set('pageOpt.unit', {
	                    pageNo: data.data.pageNo,
	                    pageSize: data.data.pageSize,
	                    totalCount: data.data.totalCount,
	                    type: self.pageOpt.unit.type
	                });
	                if (self.unitList.list.length > 0) {
	                    self.loadPPT(self.unitList.list[0].id);
	                }
	                self.$log();
	            }
	        }, 'get');
	    },
	
	    loadPPT: function loadPPT(id) {
	        if (id != "page") {
	            this.$set("selected.unit.id", id);
	        }
	        var url = this.host + "wuyan/admin/course",
	            params = {
	            unitId: this.selected.unit.id,
	            pageNo: this.pageOpt.ppt.pageNo,
	            pageSize: this.pageOpt.ppt.pageSize
	
	        },
	            self = this;
	        _common2.default.load(url, params, function (data) {
	            if (data.code) {
	                _common2.default.topRightInfoTips({
	                    content: data.message
	                });
	                self.$set('PPTList.list', []);
	            } else {
	                self.$set('PPTList', data.data);
	                self.pageOpt.ppt.pageNo = data.data.pageNo;
	                self.$set('pageOpt.ppt.totalCount', data.data.totalCount);
	                self.$set('pageOpt.ppt.type', 'ppt');
	            }
	        }, 'get');
	    },
	
	    openPPTmodal: function openPPTmodal(index) {
	        var vm = this;
	        this.$set('modal.ppt', JSON.parse((0, _stringify2.default)(vm.PPTList.list[index])));
	        this.$set('modal.ppt.pptImages', JSON.parse(this.PPTList.list[index].pptImages));
	        this.$log();
	        $('.ppt-modal').modal('show');
	
	        this.$nextTick(function () {
	            var mySwiper = new Swiper('.swiper-container', {
	                prevButton: '.swiper-button-prev',
	                nextButton: '.swiper-button-next'
	            });
	        });
	    },
	
	    turnPage: function turnPage(data) {
	        if (data.type === 'ppt') {
	            this.pageOpt.ppt = data;
	            this.loadPPT('page');
	        } else if (data.type === 'unit') {
	            this.pageOpt.unit = data;
	            this.loadUnit();
	        }
	    }
	
	}), _components$events$da);
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(3)))

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _common = __webpack_require__(2);
	
	var _common2 = _interopRequireDefault(_common);
	
	var _config = __webpack_require__(1);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    data: function data() {
	        return {
	            postParam: {},
	            host: _config2.default.host,
	            bookList: {},
	            pageOpt: {
	                list: {
	                    pageNo: 1
	                }
	            },
	            typeName: {},
	            gradeId: {},
	            generalId: null,
	            gradeList: null,
	            databanben: []
	        };
	    },
	    created: function created() {
	        var self = this;
	        _common2.default.getAllType("admin", function (data) {
	            self.$set('typeName', data);
	            self.findbanben();
	        });
	    },
	    methods: {
	        imgError: function imgError(index) {
	            this.$set('bookList.list[' + index + '].logo', 'http://qiniu.ludanmall.com/472/commend/logo/千库网-素材书图片_1480562667018.png');
	        },
	        selectGeneralId: function selectGeneralId(id) {
	            this.generalId = id;
	            this.$set('gradeList', this.showClass(id));
	        },
	
	        showClass: function showClass(id) {
	            var primary = {
	                1: "一年级(上)",
	                10: "一年级(下)",
	                2: "二年级(上)",
	                11: "二年级(下)",
	                3: "三年级(上)",
	                12: "三年级(下)",
	                4: "四年级(上)",
	                13: "四年级(下)",
	                14: "五年级(下)",
	                5: "五年级(上)",
	                6: "六年级(上)",
	                15: "六年级(下)"
	            },
	                junior = {
	                7: "七年级(上)",
	                8: "八年级(上)",
	                9: "九年级(上)",
	                16: "七年级(下)",
	                17: "八年级(下)",
	                18: "九年级(下)"
	            },
	                height = {
	                27: "高三(下)",
	                26: "高三(上)",
	                25: "高二(下)",
	                24: "高二(上)",
	                23: "高一(下)",
	                22: "高一(上)"
	            };
	            var gra = [primary, junior, height];
	            return gra[id - 1];
	        },
	
	        loadList: function loadList() {
	            var url = this.host + "wuyan/user/book",
	                params = {
	                pageNo: this.pageOpt.pageNo,
	                pageSize: 100,
	                gradeId: this.gradeId
	            },
	                self = this;
	            _common2.default.load(url, params, function (data) {
	                if (data.code) {
	                    data.data = { list: [], pageNo: 1, totalCount: 0 };
	                }
	                data.data.list.forEach(function (a) {
	                    self.databanben.forEach(function (b) {
	                        if (b.id == a.versionId) {
	                            a.versionId = b.name;
	                        }
	                    });
	                });
	                self.$set("bookList", data.data);
	            }, 'get');
	        },
	        findbanben: function findbanben() {
	            var url = this.host + 'wuyan/admin/version';
	            var self = this;
	            var postParam = {};
	            _common2.default.load(url, postParam, function (data) {
	                self.$set('databanben', data.data);
	                self.loadList();
	            }, 'get');
	        }
	    }
	};

/***/ }),
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */,
/* 157 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */,
/* 160 */,
/* 161 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 163 */,
/* 164 */,
/* 165 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 166 */,
/* 167 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 168 */,
/* 169 */,
/* 170 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 175 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 181 */,
/* 182 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 190 */,
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.a4d18da.png";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/qrcode.fd84c33.jpg";

/***/ }),
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */
/***/ (function(module, exports) {

	module.exports = " <div class=content _v-15630612=\"\"> <top _v-15630612=\"\"></top> <router-view _v-15630612=\"\"></router-view> <my-footer _v-15630612=\"\"></my-footer> </div> ";

/***/ }),
/* 197 */,
/* 198 */
/***/ (function(module, exports) {

	module.exports = " <div class=quick-banner _v-1aff5fc6=\"\"> <div class=container _v-1aff5fc6=\"\"> <header _v-1aff5fc6=\"\"> <h1 _v-1aff5fc6=\"\">产品展示</h1> <div class=bottom-nav _v-1aff5fc6=\"\"> <div @click=loadList($key) v-for=\"one in typeName.general\" class=bottom-type :class=\"{active: generalId==$key}\" _v-1aff5fc6=\"\"> <p _v-1aff5fc6=\"\">{{one}}</p> </div> </div> </header> </div> </div> <div class=container _v-1aff5fc6=\"\"> <div v-if=!bookList.list||!bookList.list.length style=\"text-align: center\" _v-1aff5fc6=\"\">暂无数据</div> <div class=row style=margin-top:20px _v-1aff5fc6=\"\"> <div v-for=\"one in bookList.list\" class=col-xs-2 _v-1aff5fc6=\"\"> <div class=show-block _v-1aff5fc6=\"\"> <a v-link=\"{path :'/index/listenbookpc'}\" _v-1aff5fc6=\"\"> <img :src=one.images @error=imgError _v-1aff5fc6=\"\"> <div class=float-title _v-1aff5fc6=\"\"> <p _v-1aff5fc6=\"\">{{one.name}}</p> </div> </a> </div> </div> </div> </div> <div class=\"modal fade\" id=myModal tabindex=-1 role=dialog aria-labelledby=myModalLabel aria-hidden=true _v-1aff5fc6=\"\"> <div class=\"modal-dialog modal-lg\" _v-1aff5fc6=\"\"> <div class=modal-content _v-1aff5fc6=\"\"> <div class=modal-header _v-1aff5fc6=\"\"> <button type=button class=close data-dismiss=modal _v-1aff5fc6=\"\"><span aria-hidden=true _v-1aff5fc6=\"\">×</span><span class=sr-only _v-1aff5fc6=\"\">Close</span></button> <h4 class=modal-title id=myModalLabel _v-1aff5fc6=\"\">Modal title</h4> </div> <div class=modal-body _v-1aff5fc6=\"\"> ... </div> <div class=modal-footer _v-1aff5fc6=\"\"> <button type=button class=\"btn btn-default\" data-dismiss=modal _v-1aff5fc6=\"\">Close</button> <button type=button class=\"btn btn-primary\" _v-1aff5fc6=\"\">Save changes</button> </div> </div> </div> </div> ";

/***/ }),
/* 199 */
/***/ (function(module, exports) {

	module.exports = " <div class=content-wy _v-1d375d76=\"\"> <p _v-1d375d76=\"\">公司文化</p> <table class=\"table table-hover\" _v-1d375d76=\"\"> <template v-for=\"infodata in infodata\"> <tr v-if=\"infodata.id!=68\" _v-1d375d76=\"\"> <td _v-1d375d76=\"\">{{infodata.content.account}}</td> <td style=\"width: 110px;cursor: pointer\" _v-1d375d76=\"\"> <a href={{infodata.content.alink}} target=_blank _v-1d375d76=\"\"> 查看详情 <span class=\"glyphicon glyphicon-chevron-right\" _v-1d375d76=\"\"></span><span class=\"glyphicon glyphicon-chevron-right\" _v-1d375d76=\"\"></span> </a> </td> </tr> </template> </table> <page :turn-page=pageData _v-1d375d76=\"\"></page> </div> ";

/***/ }),
/* 200 */,
/* 201 */,
/* 202 */
/***/ (function(module, exports) {

	module.exports = " <div class=conText _v-241dc240=\"\"> <div class=backcolor _v-241dc240=\"\"> <div _v-241dc240=\"\"> <h2 class=h2css _v-241dc240=\"\">联系我们 &nbsp;&nbsp;<span style=font-family:cursive;font-size:19px _v-241dc240=\"\">CONTACT US</span> </h2> </div> <div v-html=link.content.content style=\"padding: 10px\" _v-241dc240=\"\"></div> </div> </div> ";

/***/ }),
/* 203 */
/***/ (function(module, exports) {

	module.exports = " <nav class=\"topnav navbar-default\" _v-321a93aa=\"\"> <img style=\"width: 302px; float: left; margin: 5px 0 5px 63px\" src=http://img.scwywh.com/wuyuan/admin/norisuke/吾言文化公司标志02_1481891930391.png alt=\"\" _v-321a93aa=\"\"> <ul _v-321a93aa=\"\"> <li _v-321a93aa=\"\"><a v-link=\"{path :'/index/pc', activeClass: 'active' }\" _v-321a93aa=\"\">首页</a></li> <li v-link-active=\"\" _v-321a93aa=\"\"><a v-link=\"{path :'/index/workList', activeClass: 'active' }\" _v-321a93aa=\"\">课件下载</a></li> <li v-link-active=\"\" _v-321a93aa=\"\"><a v-link=\"{path :'/index/listendownpc?type=en', activeClass: 'active' }\" _v-321a93aa=\"\">英语听力</a></li> <li v-link-active=\"\" _v-321a93aa=\"\"><a v-link=\"{path :'/index/listendownpc?type=cn', activeClass: 'active' }\" _v-321a93aa=\"\">语文听读</a></li> <li v-link-active=\"\" _v-321a93aa=\"\"><a v-link=\"{path :'/index/norisukeList', activeClass: 'active' }\" _v-321a93aa=\"\">产品展示</a></li> <li v-link-active=\"\" _v-321a93aa=\"\"><a v-link=\"{path :'/index/findinfopc', activeClass: 'active' }\" _v-321a93aa=\"\">公司文化</a></li> <li v-link-active=\"\" _v-321a93aa=\"\"><a v-link=\"{path :'/index/tellOur', activeClass: 'active' }\" _v-321a93aa=\"\">联系我们</a></li> </ul> <div class=sign _v-321a93aa=\"\"> <template v-if=localdata.id> <strong _v-321a93aa=\"\">Hi,您好!{{localdata.name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</strong> <button type=button class=\"btn btn-sm btn-primary\" @click=out _v-321a93aa=\"\">注销登陆</button> </template> <template v-else=\"\"> <button type=button class=\"btn btn-primary\" data-toggle=modal data-target=.login _v-321a93aa=\"\">登录</button> <button type=button class=\"btn btn-success\" data-toggle=modal data-target=.reg _v-321a93aa=\"\">注册</button> </template> </div> </nav> <div class=\"modal fade login\" tabindex=-1 role=dialog aria-labelledby=myModalLabel aria-hidden=true _v-321a93aa=\"\"> <div class=\"modal-dialog modal-bg\" _v-321a93aa=\"\"> <div class=modal-content _v-321a93aa=\"\"> <div class=modal-header _v-321a93aa=\"\"> <button type=button class=close data-dismiss=modal _v-321a93aa=\"\"><span aria-hidden=true _v-321a93aa=\"\">×</span><span class=sr-only _v-321a93aa=\"\">Close</span></button> <h4 class=modal-title _v-321a93aa=\"\">登录</h4> </div> <div class=modal-body _v-321a93aa=\"\"> <form class=form-horizontal role=form _v-321a93aa=\"\"> <div class=form-group _v-321a93aa=\"\"> <label class=\"col-sm-4 control-label\" _v-321a93aa=\"\">邮箱</label> <div class=col-sm-6 _v-321a93aa=\"\"> <input type=email class=form-control placeholder=email v-model=email _v-321a93aa=\"\"> </div> </div> <div class=form-group _v-321a93aa=\"\"> <label class=\"col-sm-4 control-label\" _v-321a93aa=\"\">密码</label> <div class=col-sm-6 _v-321a93aa=\"\"> <input type=password class=form-control placeholder=密码 v-model=password _v-321a93aa=\"\"> </div> </div> </form> </div> <div class=modal-footer _v-321a93aa=\"\"> <button type=button class=\"btn btn-default btn-sm\" data-dismiss=modal _v-321a93aa=\"\">关闭</button> <button type=button class=\"btn btn-primary btn-sm\" data-dismiss=modal @click=cLogin _v-321a93aa=\"\">登录 </button> </div> </div> </div> </div> <div class=\"modal fade reg\" id=myModal tabindex=-1 role=dialog aria-labelledby=myModalLabel aria-hidden=true _v-321a93aa=\"\"> <div class=\"modal-dialog modal-bg\" _v-321a93aa=\"\"> <div class=modal-content _v-321a93aa=\"\"> <div class=modal-header _v-321a93aa=\"\"> <button type=button class=close data-dismiss=modal _v-321a93aa=\"\"><span aria-hidden=true _v-321a93aa=\"\">×</span><span class=sr-only _v-321a93aa=\"\">Close</span></button> <h4 class=modal-title id=myModalLabel _v-321a93aa=\"\">注册信息</h4> </div> <div class=modal-body _v-321a93aa=\"\"> <form class=form-horizontal role=form _v-321a93aa=\"\"> <div class=form-group _v-321a93aa=\"\"> <label class=\"col-sm-3 control-label\" _v-321a93aa=\"\"><strong class=red _v-321a93aa=\"\">*</strong>姓名</label> <div class=col-sm-8 _v-321a93aa=\"\"> <input type=text class=form-control placeholder=姓名 v-model=reg.name _v-321a93aa=\"\"> </div> </div> <div class=form-group _v-321a93aa=\"\"> <label class=\"col-sm-3 control-label\" _v-321a93aa=\"\"><strong class=red _v-321a93aa=\"\">*</strong>邮箱</label> <div class=col-sm-8 _v-321a93aa=\"\"> <input type=email class=form-control placeholder=邮箱 v-model=reg.email _v-321a93aa=\"\"> </div> </div> <div class=form-group _v-321a93aa=\"\"> <label class=\"col-sm-3 control-label\" _v-321a93aa=\"\"><strong class=red _v-321a93aa=\"\">*</strong>电话</label> <div class=col-sm-8 _v-321a93aa=\"\"> <input type=text class=form-control placeholder=联系电话 v-model=reg.phone _v-321a93aa=\"\"> </div> </div> <div class=form-group _v-321a93aa=\"\"> <label class=\"col-sm-3 control-label\" _v-321a93aa=\"\"><strong class=red _v-321a93aa=\"\">*</strong>地址</label> <div class=col-sm-8 _v-321a93aa=\"\"> <input type=text class=form-control placeholder=地址 v-model=reg.address _v-321a93aa=\"\"> </div> </div> <div class=form-group _v-321a93aa=\"\"> <label class=\"col-sm-3 control-label\" _v-321a93aa=\"\"><strong class=red _v-321a93aa=\"\">*</strong>密码</label> <div class=col-sm-8 _v-321a93aa=\"\"> <input type=text class=form-control placeholder=密码 v-model=reg.password _v-321a93aa=\"\"> </div> </div> <div class=form-group _v-321a93aa=\"\"> <label class=\"col-sm-3 control-label\" _v-321a93aa=\"\"><strong class=red _v-321a93aa=\"\">*</strong>确认密码</label> <div class=col-sm-8 _v-321a93aa=\"\"> <input type=text class=form-control placeholder=密码 v-model=reg.passwordS _v-321a93aa=\"\"> </div> </div> <div class=form-group _v-321a93aa=\"\"> <label class=\"col-sm-3 control-label\" _v-321a93aa=\"\"><strong class=red _v-321a93aa=\"\">*</strong>学校</label> <div class=col-sm-8 _v-321a93aa=\"\"> <input type=text class=form-control placeholder=学校 v-model=reg.school _v-321a93aa=\"\"> </div> </div> </form> </div> <div class=modal-footer _v-321a93aa=\"\"> <button type=button class=\"btn btn-default btn-sm\" data-dismiss=modal _v-321a93aa=\"\">关闭</button> <button type=button class=\"btn btn-primary btn-sm\" data-dismiss=modal @click=cReg _v-321a93aa=\"\">注册</button> </div> </div> </div> </div> ";

/***/ }),
/* 204 */,
/* 205 */,
/* 206 */
/***/ (function(module, exports) {

	module.exports = " <div class=quick-banner _v-49ad1007=\"\"> <div class=container _v-49ad1007=\"\"> <header _v-49ad1007=\"\"> <h1 _v-49ad1007=\"\">听力下载</h1> <template v-if=\"urlParams.type=='cn'\"> <div class=bottom-nav _v-49ad1007=\"\"> <div class=bottom-type :class=\"{active: generalId==''}\" _v-49ad1007=\"\"> <p @click=\"findinfo('')\" _v-49ad1007=\"\">全部</p> </div> <div v-for=\"one in generaldata\" class=bottom-type :class=\"{active: generalId==one.id}\" _v-49ad1007=\"\"> <p @click=findinfo(one.id) _v-49ad1007=\"\">{{one.name}}</p> </div> </div> </template> </header> </div> </div> <div class=container style=\"margin:40px auto\" _v-49ad1007=\"\"> <div v-if=!infodata||!infodata.length style=\"text-align: center\" _v-49ad1007=\"\">暂无数据</div> <div class=row _v-49ad1007=\"\"> <div class=\"col-xs-2 listenImg\" v-for=\"infodata in infodata\" _v-49ad1007=\"\"> <div class=show-block _v-49ad1007=\"\"> <a v-link=\"{path :'/index/listenbookpc?id='+infodata.id+'&amp;name='+infodata.name}\" _v-49ad1007=\"\"> <img :src=infodata.logo style=\"height: 150px\" _v-49ad1007=\"\"> <div class=float-title _v-49ad1007=\"\"> 【{{infodata.versionId}}】{{infodata.name}} </div> </a> </div> </div> </div> <page :turn-page=pageData _v-49ad1007=\"\"></page> </div> ";

/***/ }),
/* 207 */,
/* 208 */
/***/ (function(module, exports) {

	module.exports = " <div class=container _v-51eb77af=\"\"> <div class=\"panel panel-default\" _v-51eb77af=\"\"> <div class=panel-heading _v-51eb77af=\"\">{{shopInfo.name}}</div> <div class=panel-body _v-51eb77af=\"\"> <div class=shop-info _v-51eb77af=\"\"> <div class=col-md-6 _v-51eb77af=\"\"> <img :src=shopInfo.logo alt=\"\" _v-51eb77af=\"\"> </div> <div class=col-md-6 _v-51eb77af=\"\"> <p v-html=shopInfo.introduce style=\"font-size: 14px\" _v-51eb77af=\"\"></p> <p _v-51eb77af=\"\"><span class=\"glyphicon glyphicon-phone-alt\" _v-51eb77af=\"\"></span>{{shopInfo.phone}}</p> <p _v-51eb77af=\"\"><span class=\"glyphicon glyphicon-earphone\" _v-51eb77af=\"\"></span>{{shopInfo.tel}}</p> <p _v-51eb77af=\"\"><span class=\"glyphicon glyphicon-map-marker\" _v-51eb77af=\"\"></span>{{shopInfo.city}}{{shopInfo.address}}</p> </div> </div> </div> </div> </div> <div class=\"modal fade\" id=myModal tabindex=-1 role=dialog aria-labelledby=myModalLabel aria-hidden=true _v-51eb77af=\"\"> <div class=\"modal-dialog modal-lg\" _v-51eb77af=\"\"> <div class=modal-content _v-51eb77af=\"\"> <div class=modal-header _v-51eb77af=\"\"> <button type=button class=close data-dismiss=modal _v-51eb77af=\"\"><span aria-hidden=true _v-51eb77af=\"\">×</span><span class=sr-only _v-51eb77af=\"\">Close</span></button> <h4 class=modal-title id=myModalLabel _v-51eb77af=\"\">Modal title</h4> </div> <div class=modal-body _v-51eb77af=\"\"> ... </div> <div class=modal-footer _v-51eb77af=\"\"> <button type=button class=\"btn btn-default\" data-dismiss=modal _v-51eb77af=\"\">Close</button> <button type=button class=\"btn btn-primary\" _v-51eb77af=\"\">Save changes</button> </div> </div> </div> </div> ";

/***/ }),
/* 209 */,
/* 210 */,
/* 211 */
/***/ (function(module, exports) {

	module.exports = " <div _v-63ee4518=\"\"> <router-view _v-63ee4518=\"\"></router-view> </div> ";

/***/ }),
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */
/***/ (function(module, exports) {

	module.exports = " <div class=container _v-7a7918ca=\"\"> <div class=page-header _v-7a7918ca=\"\"> <h1 _v-7a7918ca=\"\">{{bookInfo.name}} <span v-html=qrcode _v-7a7918ca=\"\"></span></h1> </div> <div v-for=\"unit in unitList.list\" class=\"panel panel-info\" _v-7a7918ca=\"\"> <div class=panel-heading _v-7a7918ca=\"\"> <h3 class=panel-title _v-7a7918ca=\"\">{{unit.name}} <button @click=loadPPT(unit.id) class=\"btn btn-default btn-xs\" _v-7a7918ca=\"\">展开ppt列表</button> </h3> </div> <div v-show=\"selected.unit.id==unit.id\" class=panel-body _v-7a7918ca=\"\"> <div v-for=\"PPT in PPTList.list\" class=col-md-6 _v-7a7918ca=\"\"> <div class=ppt-block _v-7a7918ca=\"\"> <img :src=PPT.logo :alt=PPT.name @error=imgError($index) _v-7a7918ca=\"\"> <p _v-7a7918ca=\"\">{{PPT.name}}</p> <div class=ppt-button _v-7a7918ca=\"\"> <a v-show=\"wyrole!='YES'\" class=\"btn btn-default\" @click=noAllow _v-7a7918ca=\"\">下载</a> <a v-else=\"\" class=\"btn btn-default\" :href=PPT.pptUrl target=_blank _v-7a7918ca=\"\">下载</a> <button @click=openPPTmodal($index) class=\"btn btn-default\" _v-7a7918ca=\"\">预览</button> </div> </div> </div> <page :turn-page=pageOpt.ppt _v-7a7918ca=\"\"></page> </div> </div> <page :turn-page=pageOpt.unit _v-7a7918ca=\"\"></page> <div class=\"modal ppt-modal fade\" tabindex=-1 role=dialog aria-labelledby=myModalLabel aria-hidden=true _v-7a7918ca=\"\"> <div class=modal-dialog style=\"width: 700px\" _v-7a7918ca=\"\"> <div class=modal-content _v-7a7918ca=\"\"> <div class=modal-header _v-7a7918ca=\"\"> <button type=button class=close data-dismiss=modal _v-7a7918ca=\"\"><span aria-hidden=true _v-7a7918ca=\"\">×</span><span class=sr-only _v-7a7918ca=\"\">Close</span></button> <h4 class=modal-title id=myModalLabel _v-7a7918ca=\"\">{{modal.ppt.name}}</h4> </div> <div class=modal-body _v-7a7918ca=\"\"> <div class=swiper-container _v-7a7918ca=\"\"> <div class=swiper-wrapper _v-7a7918ca=\"\"> <div v-for=\"one in modal.ppt.pptImages\" class=swiper-slide _v-7a7918ca=\"\"><img :src=one alt=\"\" _v-7a7918ca=\"\"> </div> </div> <div class=swiper-button-prev _v-7a7918ca=\"\"></div> <div class=swiper-button-next _v-7a7918ca=\"\"></div> </div> </div> <div class=modal-footer _v-7a7918ca=\"\"> <button type=button class=\"btn btn-default\" data-dismiss=modal _v-7a7918ca=\"\">关闭</button> </div> </div> </div> </div> </div> ";

/***/ }),
/* 216 */
/***/ (function(module, exports) {

	module.exports = " <div class=quick-banner _v-7fda268c=\"\"> <div class=container _v-7fda268c=\"\"> <header _v-7fda268c=\"\"> <h1 _v-7fda268c=\"\">课件下载</h1> <div class=bottom-nav _v-7fda268c=\"\"> <div @click=selectGeneralId(1) class=bottom-type :class=\"{active: generalId==1}\" _v-7fda268c=\"\"> <p _v-7fda268c=\"\">小学</p> </div> <div @click=selectGeneralId(2) class=bottom-type :class=\"{active: generalId==2}\" _v-7fda268c=\"\"> <p _v-7fda268c=\"\">初中</p> </div> <div @click=selectGeneralId(3) class=bottom-type :class=\"{active: generalId==3}\" _v-7fda268c=\"\"> <p _v-7fda268c=\"\">高中</p> </div> </div> <div class=bottom-nav _v-7fda268c=\"\"> <div :class=\"{grade3: generalId==3}\" _v-7fda268c=\"\"> <template v-for=\"one in gradeList\"> <div @click=loadList class=bottom-type :class=\"{active: gradeId==$key}\" _v-7fda268c=\"\"> <p @click=\"gradeId=$key\" _v-7fda268c=\"\">{{one}}</p> </div> <br v-if=\"$key==9\" _v-7fda268c=\"\"> </template> </div> </div> </header> </div> </div> <div class=container _v-7fda268c=\"\"> <div v-if=!bookList.list||!bookList.list.length style=\"text-align: center\" _v-7fda268c=\"\">暂无数据！</div> <div class=row style=margin-top:20px _v-7fda268c=\"\"> <div v-for=\"one in bookList.list\" class=col-xs-2 _v-7fda268c=\"\"> <div class=show-block _v-7fda268c=\"\"> <a v-link=\"'/index/workInfo?id='+one.id\" _v-7fda268c=\"\"> <img :src=\"one.logo+'?imageView2/0/h/160'\" @error=imgError($index) _v-7fda268c=\"\"> <div class=float-title _v-7fda268c=\"\"> <p _v-7fda268c=\"\">【{{one.versionId}}】{{one.name}}</p> </div> </a> </div> </div> </div> </div> <div class=\"modal fade\" id=myModal tabindex=-1 role=dialog aria-labelledby=myModalLabel aria-hidden=true _v-7fda268c=\"\"> <div class=\"modal-dialog modal-lg\" _v-7fda268c=\"\"> <div class=modal-content _v-7fda268c=\"\"> <div class=modal-header _v-7fda268c=\"\"> <button type=button class=close data-dismiss=modal _v-7fda268c=\"\"><span aria-hidden=true _v-7fda268c=\"\">×</span><span class=sr-only _v-7fda268c=\"\">Close</span></button> <h4 class=modal-title id=myModalLabel _v-7fda268c=\"\">Modal title</h4> </div> <div class=modal-body _v-7fda268c=\"\"> ... </div> <div class=modal-footer _v-7fda268c=\"\"> <button type=button class=\"btn btn-default\" data-dismiss=modal _v-7fda268c=\"\">Close</button> <button type=button class=\"btn btn-primary\" _v-7fda268c=\"\">Save changes</button> </div> </div> </div> </div> ";

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */
/***/ (function(module, exports) {

	module.exports = " <div class=container _v-a63307a6=\"\"> <h1 _v-a63307a6=\"\">{{shopInfo.name}}</h1> <div _v-a63307a6=\"\"> <ul _v-a63307a6=\"\"> <li _v-a63307a6=\"\"> 类型：{{shopInfo.generalName}} </li> <li _v-a63307a6=\"\"> 版本：{{shopInfo.versionName}} </li> </ul> <div class=content _v-a63307a6=\"\"> <img class=logo :src=shopInfo.images _v-a63307a6=\"\"> <div v-html=shopInfo.content _v-a63307a6=\"\"></div> </div> </div> </div> ";

/***/ }),
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = " <div class=pc _v-b991f0c4=\"\"> <div class=swiper-first _v-b991f0c4=\"\"> <div class=swiper-wrapper _v-b991f0c4=\"\"> <div class=\"swiper-slide page1\" _v-b991f0c4=\"\"> <img src=" + __webpack_require__(47) + " alt=\"\" _v-b991f0c4=\"\"> </div> <div class=\"swiper-slide page2\" _v-b991f0c4=\"\"> <img src=" + __webpack_require__(45) + " alt=\"\" _v-b991f0c4=\"\"> </div> <div class=\"swiper-slide page3\" _v-b991f0c4=\"\"> <img src=" + __webpack_require__(46) + " alt=\"\" _v-b991f0c4=\"\"> </div> </div> </div> <div _v-b991f0c4=\"\"> <div class=qrcode _v-b991f0c4=\"\"> <img src=" + __webpack_require__(191) + " alt=\"\" _v-b991f0c4=\"\"> <img src=" + __webpack_require__(192) + " alt=\"\" _v-b991f0c4=\"\"> <p _v-b991f0c4=\"\"> 扫一扫了解更多资讯</p> </div> <div class=container style=overflow:hidden _v-b991f0c4=\"\"> <div class=hot-work v-show=NoseList[1]&amp;&amp;NoseList[1].list.length _v-b991f0c4=\"\"> <div class=\"panel panel-default\" _v-b991f0c4=\"\"> <div class=panel-heading _v-b991f0c4=\"\">小学教辅推荐</div> <div class=panel-body _v-b991f0c4=\"\"> <div class=\"swiper-container swiper-container-list\" _v-b991f0c4=\"\"> <div class=swiper-wrapper _v-b991f0c4=\"\"> <div v-for=\"one in NoseList[1]&amp;&amp;NoseList[1].list\" class=swiper-slide _v-b991f0c4=\"\"> <div class=show-block _v-b991f0c4=\"\"> <a v-link=\"'/index/norisukeInfo?id='+one.id\" _v-b991f0c4=\"\"> <img :src=one.images @error=imgError($index) _v-b991f0c4=\"\"> <div class=float-title _v-b991f0c4=\"\"> <p _v-b991f0c4=\"\">{{one.name}}</p> </div> </a> </div> </div> </div> </div> </div> </div> </div> <div class=hot-work v-show=NoseList[2]&amp;&amp;NoseList[2].list.length _v-b991f0c4=\"\"> <div class=\"panel panel-default\" _v-b991f0c4=\"\"> <div class=panel-heading _v-b991f0c4=\"\">中学教辅推荐</div> <div class=panel-body _v-b991f0c4=\"\"> <div class=\"swiper-container swiper-container-list\" _v-b991f0c4=\"\"> <div class=swiper-wrapper _v-b991f0c4=\"\"> <div v-for=\"one in NoseList[2]&amp;&amp;NoseList[2].list\" class=swiper-slide _v-b991f0c4=\"\"> <div class=show-block _v-b991f0c4=\"\"> <a v-link=\"'/index/norisukeInfo?id='+one.id\" _v-b991f0c4=\"\"> <img :src=one.images @error=imgError($index) _v-b991f0c4=\"\"> <div class=float-title _v-b991f0c4=\"\"> <p _v-b991f0c4=\"\">{{one.name}}</p> </div> </a> </div> </div> </div> </div> </div> </div> </div> <div class=hot-work v-show=NoseList[3]&amp;&amp;NoseList[3].list.length _v-b991f0c4=\"\"> <div class=\"panel panel-default\" _v-b991f0c4=\"\"> <div class=panel-heading _v-b991f0c4=\"\">高中教辅推荐</div> <div class=panel-body _v-b991f0c4=\"\"> <div class=\"swiper-container swiper-container-list\" _v-b991f0c4=\"\"> <div class=swiper-wrapper _v-b991f0c4=\"\"> <div v-for=\"one in NoseList[3]&amp;&amp;NoseList[3].list\" class=swiper-slide _v-b991f0c4=\"\"> <div class=show-block _v-b991f0c4=\"\"> <a v-link=\"'/index/norisukeInfo?id='+one.id\" _v-b991f0c4=\"\"> <img :src=one.images @error=imgError($index) _v-b991f0c4=\"\"> <div class=float-title _v-b991f0c4=\"\"> <p _v-b991f0c4=\"\">{{one.name}}</p> </div> </a> </div> </div> </div> </div> </div> </div> </div> <div class=hot-work v-show=NoseList[9]&amp;&amp;NoseList[9].list.length _v-b991f0c4=\"\"> <div class=\"panel panel-default\" _v-b991f0c4=\"\"> <div class=panel-heading _v-b991f0c4=\"\">新品字帖推荐</div> <div class=panel-body _v-b991f0c4=\"\"> <div class=\"swiper-container swiper-container-list\" _v-b991f0c4=\"\"> <div class=swiper-wrapper _v-b991f0c4=\"\"> <div v-for=\"one in NoseList[9]&amp;&amp;NoseList[9].list\" class=swiper-slide _v-b991f0c4=\"\"> <div class=show-block _v-b991f0c4=\"\"> <a v-link=\"'/index/norisukeInfo?id='+one.id\" _v-b991f0c4=\"\"> <img :src=one.images @error=imgError($index) _v-b991f0c4=\"\"> <div class=float-title _v-b991f0c4=\"\"> <p _v-b991f0c4=\"\">{{one.name}}</p> </div> </a> </div> </div> </div> </div> </div> </div> </div> <div class=hot-work v-show=NoseList[6]&amp;&amp;NoseList[6].list.length _v-b991f0c4=\"\"> <div class=\"panel panel-default\" _v-b991f0c4=\"\"> <div class=panel-heading _v-b991f0c4=\"\">其他图书推荐</div> <div class=panel-body _v-b991f0c4=\"\"> <div class=\"swiper-container swiper-container-list\" _v-b991f0c4=\"\"> <div class=swiper-wrapper _v-b991f0c4=\"\"> <div v-for=\"one in NoseList[6]&amp;&amp;NoseList[6].list\" class=swiper-slide _v-b991f0c4=\"\"> <div class=show-block _v-b991f0c4=\"\"> <a v-link=\"'/index/norisukeInfo?id='+one.id\" _v-b991f0c4=\"\"> <img :src=one.images @error=imgError($index) _v-b991f0c4=\"\"> <div class=float-title _v-b991f0c4=\"\"> <p _v-b991f0c4=\"\">{{one.name}}</p> </div> </a> </div> </div> </div> </div> </div> </div> </div> <div class=hot-work v-show=shopList.list&amp;&amp;shopList.list.length _v-b991f0c4=\"\"> <div class=\"panel panel-default\" _v-b991f0c4=\"\"> <div class=panel-heading _v-b991f0c4=\"\">热点书店推荐</div> <div class=panel-body _v-b991f0c4=\"\"> <div class=\"swiper-container swiper-container-shop\" _v-b991f0c4=\"\"> <div class=swiper-wrapper _v-b991f0c4=\"\"> <div v-for=\"one in shopList.list\" class=swiper-slide _v-b991f0c4=\"\"> <div class=show-block _v-b991f0c4=\"\"> <a v-link=\"'/index/shopInfo?id='+one.id\" _v-b991f0c4=\"\"> <img :src=one.logo @error=imgError($index) _v-b991f0c4=\"\"> <div class=float-title _v-b991f0c4=\"\"> <p _v-b991f0c4=\"\">{{one.name}}</p> </div> </a> </div> </div> </div> </div> </div> </div> </div> </div> </div> </div> ";

/***/ }),
/* 224 */,
/* 225 */,
/* 226 */
/***/ (function(module, exports) {

	module.exports = " <footer _v-c27f1238=\"\"> <div _v-c27f1238=\"\"> <span class=gold _v-c27f1238=\"\">地址:</span> 四川省成都市金牛区沙湾东二路5号智业·世纪加州B座19层3/4号 </div> <div _v-c27f1238=\"\"> <span _v-c27f1238=\"\">联系人:</span>蒋经理 <span _v-c27f1238=\"\">电话:</span> 13881832866 <span _v-c27f1238=\"\">座机:</span> 028-69089266 <span _v-c27f1238=\"\">邮件:</span> scwywh@126.com </div> <div _v-c27f1238=\"\"> COPYRIGHT © 2015-2017 www.scwywh.com. All Rights Reserved 吾言文化有限公司版权所有 <a href=https://beian.miit.gov.cn/ target=_blank _v-c27f1238=\"\">网站备案号(蜀ICP备15005400号)</a> </div> </footer> ";

/***/ }),
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ (function(module, exports) {

	module.exports = " <div class=content-wy _v-f943d5e4=\"\"> <div class=page-header _v-f943d5e4=\"\"> <h1 _v-f943d5e4=\"\">{{datainfo.name}}听力列表 <span v-html=qrcode _v-f943d5e4=\"\"></span> </h1> <h2 _v-f943d5e4=\"\">{{URLcs.name}}</h2> </div> <table class=\"table table-hover\" _v-f943d5e4=\"\"> <tbody _v-f943d5e4=\"\"><tr v-for=\"datainfo in datainfo\" _v-f943d5e4=\"\"> <td _v-f943d5e4=\"\">{{datainfo.name}}</td> <td style=\"width: 45px;cursor: pointer\" @click=findthistl(datainfo.url) data-toggle=modal data-target=.shiting _v-f943d5e4=\"\">试听</td> <template v-if=\"wyrole == 'YES'\"> <td style=\"width: 80px;cursor: pointer\" _v-f943d5e4=\"\"><a href={{datainfo.url}} download=download target=_blank _v-f943d5e4=\"\">【下载】</a></td> </template> <template v-else=\"\"> <td style=\"width: 80px;cursor: pointer\" @click=download($index) _v-f943d5e4=\"\"><a _v-f943d5e4=\"\">【下载】</a></td> </template> </tr> </tbody></table> <page :turn-page=pageData _v-f943d5e4=\"\"></page> </div> <div class=\"modal fade shiting\" id=myModal tabindex=-1 role=dialog aria-labelledby=myModalLabel aria-hidden=true _v-f943d5e4=\"\"> <div class=\"modal-dialog modal-bg\" _v-f943d5e4=\"\"> <div class=modal-content _v-f943d5e4=\"\"> <div class=modal-header _v-f943d5e4=\"\"> <button type=button class=close data-dismiss=modal _v-f943d5e4=\"\"><span aria-hidden=true _v-f943d5e4=\"\">×</span><span class=sr-only _v-f943d5e4=\"\">Close</span></button> <h4 class=modal-title id=myModalLabel _v-f943d5e4=\"\">试听</h4> </div> <div class=modal-body _v-f943d5e4=\"\"> <div style=\"text-align: center\" _v-f943d5e4=\"\"> <player :src=url _v-f943d5e4=\"\"></player> </div> </div> <div class=modal-footer _v-f943d5e4=\"\"> <button type=button class=\"btn btn-default btn-sm\" data-dismiss=modal _v-f943d5e4=\"\">关闭</button> </div> </div> </div> </div> ";

/***/ }),
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(170)
	__vue_script__ = __webpack_require__(101)
	__vue_template__ = __webpack_require__(211)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(162)
	__vue_script__ = __webpack_require__(103)
	__vue_template__ = __webpack_require__(203)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(158)
	__vue_script__ = __webpack_require__(104)
	__vue_template__ = __webpack_require__(199)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(189)
	__vue_script__ = __webpack_require__(106)
	__vue_template__ = __webpack_require__(230)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(165)
	__vue_script__ = __webpack_require__(107)
	__vue_template__ = __webpack_require__(206)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(180)
	__vue_script__ = __webpack_require__(108)
	__vue_template__ = __webpack_require__(221)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(157)
	__vue_script__ = __webpack_require__(109)
	__vue_template__ = __webpack_require__(198)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(167)
	__vue_script__ = __webpack_require__(111)
	__vue_template__ = __webpack_require__(208)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(161)
	__vue_script__ = __webpack_require__(112)
	__vue_template__ = __webpack_require__(202)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(174)
	__vue_script__ = __webpack_require__(113)
	__vue_template__ = __webpack_require__(215)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	var __vue_styles__ = {}
	__webpack_require__(175)
	__vue_script__ = __webpack_require__(114)
	__vue_template__ = __webpack_require__(216)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	var __vue_options__ = typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports
	if (__vue_template__) {
	__vue_options__.template = __vue_template__
	}
	if (!__vue_options__.computed) __vue_options__.computed = {}
	Object.keys(__vue_styles__).forEach(function (key) {
	var module = __vue_styles__[key]
	__vue_options__.computed[key] = function () { return module }
	})


/***/ })
]);


// WEBPACK FOOTER //
// static/js/wuyan.a00e5e8f865ea5eeaa97.js